<template>
  <div class="home-tab-wrapper">
    <div class="home-tab-left">
      <!-- Tab 标签 -->
      <div class="tab-header"
        v-if="easyappIframe.length > 0 && hasPermission(this.userInfo.roleActionList, 'easyapp_stats') && !hasPermissionNot(this.userInfo.roleActionList, 'no_call_stats')">
        <div v-for="tab in tabs" :key="tab.name" :class="['tab-item', { active: currentTab === tab.name }]"
          @click="currentTab = tab.name">
          {{ tab.label }}
        </div>
      </div>
      <div class="tab-content" v-show="currentTab === 'call'">
        <div class="iframe-wrapper" v-for="item in showIframe" :key="item.item_name">
          <iframe :src="item.item_url" width="100%" height="100%" frameborder="0" />
        </div>
        <div class="iframe-wrapper noShow" v-for="item in noShowIframe" :key="item.item_name">
          <iframe :src="item.item_url" width="100%" height="100%" frameborder="0" />
        </div>
      </div>
      <div class="tab-content" v-show="currentTab === 'ticket'">
        <div class="iframe-wrapper" v-for="item in easyappIframe" :key="item.item_name">
          <iframe :src="item.item_url" width="100%" height="100%" frameborder="0" />
        </div>
      </div>

    </div>
    <div class="home-tab-right" v-if="noShowInfo()">
      <div class="item BaseInfo margin-b-12"
        v-if="(!hasPermissionNot(this.userInfo.roleActionList, 'no_show_base') || !hasPermissionNot(this.userInfo.roleActionList, 'no_show_license'))">
        <BaseInfo />
      </div>
      <div v-if="!isQidian && !hasPermissionNot(this.userInfo.roleActionList, 'no_show_notice')"
        class="item margin-b-12">
        <NoticeSys />
      </div>
      <div v-if="!isQidian && !hasPermissionNot(this.userInfo.roleActionList, 'no_show_product')"
        class="item margin-b-12">
        <ProductFamily />
      </div>
    </div>
    <div class="no-module"
      v-if=" this.hasPermissionNot(this.userInfo.roleActionList, 'no_call_stats') && !this.hasPermission(this.userInfo.roleActionList, 'easyapp_stats') && !noShowInfo() && (!(easyappIframe.length > 0 && hasPermission(this.userInfo.roleActionList, 'easyapp_stats') && !hasPermissionNot(this.userInfo.roleActionList, 'no_call_stats')))">
      <img :src="noMoudleUrl" alt=""></img>
      <p class="p-one">{{ $t('home.noData') }}</p>
      <p>{{ $t('home.noDataConfig') }}</p>
    </div>
  </div>
</template>
<script>
import BaseInfo from "./baseInfo";
import NoticeSys from "./noticeSys";
import ProductFamily from "./productFamily";
import noMoudleUrl from "@/assets/images/no-module.png"
import { mapState } from 'vuex';
import mixins from "@/mixins";
export default {
  name: "Info",
  mixins: [mixins],
  components: {
    BaseInfo,
    NoticeSys,
    ProductFamily,
  },
  mounted() {
    this.setDash();
    this.getCurrentTab();
    this._Bus.$on("updateAppConfig", () => {
      this.setDash();
    });
  },
  data() {
    return {
      dash: [],
      showIframe: [],
      noShowIframe: [],
      isQidian: location.hash.includes('qidian/admin') || location.hash.includes('qidian/agent'),
      easyappIframe: [],
      tabs: [
        { name: 'call', label: this.$t('home.callStats') },
        { name: 'ticket', label: this.$t('home.ticketStats') }
      ],
      currentTab: 'ticket',
      noMoudleUrl: noMoudleUrl
    };
  },
  computed: {
    //拿到 vuex中的用户信息userInfo
    ...mapState(["userInfo"]),
  },
  methods: {
    setDash() {
      const { dashboard = [] } = this._config.URL;
      let dash = dashboard.map((item) => {
        const { item_options } = item;
        if (item_options) {
          return { ...item, ...item_options };
        }
        return { ...item };
      });

      let showIframe = dash.filter(
        (item) => item.display !== "none" && item.item_name !== "easyapp"
      );
      let noShowIframe = dash.filter((item) => item.display == "none");
      this.dash = dash;
      this.showIframe = showIframe
      this.easyappIframe = dash.filter(
        (item) => item.item_name === "easyapp"
      );
      setTimeout(() => {
        this.noShowIframe = noShowIframe;
      }, 8000);
    },
    //初始化默认tab
    getCurrentTab() {
      this.currentTab = !this.hasPermissionNot(this.userInfo.roleActionList, 'no_call_stats') ? 'call' : (this.hasPermission(this.userInfo.roleActionList, 'easyapp_stats') ? 'ticket' : 0);
    },
    //右侧信息是否都没有权限
    noShowInfo() {
      return !this.hasPermissionNot(this.userInfo.roleActionList, 'no_show_base') || !this.hasPermissionNot(this.userInfo.roleActionList, 'no_show_license') || !this.hasPermissionNot(this.userInfo.roleActionList, 'no_show_notice') || !this.hasPermissionNot(this.userInfo.roleActionList, 'no_show_product');
    }
  },
};
</script>
<style lang="less" scoped>
.margin-b-12 {
  margin-bottom: 12px;
}

.home-tab-wrapper {
  height: 100%;
  display: flex;

  .home-tab-left {
    flex: 1;
    margin-right: 12px;
    display: flex;
    flex-direction: column;

    .tab-header {
      display: flex;
      background-color: #fff;

      .tab-item {
        text-align: center;
        margin: 12px 16px 0;
        padding-bottom: 12px;
        background-color: #fff;
        cursor: pointer;
        border-radius: 2px;
        margin-right: 6px;

        &:last-child {
          margin-right: 0;
        }

        &.active {
          color: #409EFF;
          border-bottom: 2px solid #409EFF;
        }
      }
    }

    .tab-content {
      flex: 1;
      display: flex;
      flex-direction: column;

      .iframe-wrapper {
        flex: 1;

        &.noShow {
          flex: none;
          height: 0;
        }

        &:not(:last-child) {
          margin-bottom: 12px;
        }
      }
    }

  }

  .home-tab-right {
    min-height: 500px;
    width: 400px;
    display: flex;
    flex-direction: column;

    .item {
      border-radius: 2px;
      background-color: #fff;
      flex: 1;
      overflow: hidden;

      &.BaseInfo {
        // height: 210px;
        flex: none;
      }
    }
  }

  .no-module {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 100%;

    img {
      width: 320px;
      height: 242px;
    }

    .p-one {
      margin-bottom: 16px;
      font-weight: 500;
      font-size: 18px;
      color: #323233;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/homeTab/index.vue